export default __webpack_public_path__ + "static/media/hht1_ani_05.0d09ccfa.png";